<template lang="pug">

  v-tooltip(top color="rgba(0, 0, 139, 0.95)")

    template(v-slot:activator="{ on, attrs }")
      .shift__card(
        v-bind="attrs"
        v-on="on"
        :style="{ 'backgroundColor': !!shift.bgColor === true ? shift.bgColor : null }"
        :class="{ [shift.dutyStatus.join(' ')]: true, 'shift__card--hasLabel': hideProgress === false && (shift.solicitado || shift.dutyStatus.some(s => ['shift__card--passando', 'shift__card--encerrado', 'shift__card--iniciado', 'shift__card--pausado', 'shift__card--retomado'].includes(s))), 'shift__card--hasUser': shift.isUserDuty, 'shift__card--hasScale': showScaleName && shift.scaleName, /* 'dutyDetailsBody--withScale': showScaleName, */ 'shift__card--hasValue': showValue && shift.valor > 0 }"
        @click.stop.prevent="open"
      )
        //-
          - LABELS
          -

        span.shiftStatus(v-if="hideProgress === false && shift.solicitado === true") SOLICITADO
        span.shiftStatus(v-if="hideProgress === false && shift.dutyStatus.includes('shift__card--passando')") PASSANDO
        span.shiftStatus(v-if="hideProgress === false && shift.dutyStatus.includes('shift__card--encerrado')") ENCERRADO
        span.shiftStatus(v-if="hideProgress === false && shift.dutyStatus.includes('shift__card--iniciado')") INICIADO
        span.shiftStatus(v-if="hideProgress === false && shift.dutyStatus.includes('shift__card--pausado')") PAUSADO
        span.shiftStatus(v-if="hideProgress === false && shift.dutyStatus.includes('shift__card--retomado')") RETOMADO

        //-
          - BODY
          -

        template

          span.dutyDetailsUserName(v-if="shift.isUserDuty" :title="shift.userName")
            span.userNameValue {{ shift.userName }}
          span.dutyDetailsUserName(v-else-if="shift.isCanceled" title="Cancelado")
            span.userNameValue Cancelado
          span.dutyDetailsUserName(v-else-if="shift.isExpired" title="Vencido")
            span.userNameValue Vencido
          span.dutyDetailsUserName(v-else title="Disponível")
            span.userNameValue Disponível

          //- DURAÇÃO

          .shiftBodyItem
            span.shiftStartTimeTitle Duração:
            span.shiftStartTime(:title="`Duração: ${shift.shiftDuration}`")
              | &nbsp;{{ shift.shiftDuration }}

          //- ESCALA

          .shiftBodyItem(v-if="showScaleName && shift.scaleName" :title="`Escala: ${shift.scaleName}`")
            span.shiftStartTimeTitle Escala:
            span.shiftScaleName
              | &nbsp;{{ shift.scaleName }}

        //-
          - PASSING
          -

        .shiftUserImageGroup(v-if="shift.isUserPassingThisShift")
          i(aria-hidden="true" class="v-icon notranslate mdi mdi-arrow-right-bold")
          .shiftUserImage.shiftUserImage--receiver(:style="{ backgroundImage: `url(${shift.receivingPicture})` }")
          .shiftUserImage.shiftUserImage--sender(:style="{ backgroundImage: `url(${shift.image})` }")
        .shiftUserImage.shiftUserImage--one(v-else :style="{ backgroundImage: `url(${shift.image})` }")

        //-
          - VALUE
          -

        span(v-if="showValue && shift.valor > 0" class="dutyUserValue") {{ shift.formattedValue }}

    //-
      - TOOLTIP CONTENT
      -

    .shiftInfoItem(v-if="shift.scaleName.length > 0")
      b.shiftInfoItemName.shiftInfoItemName--scaleName &nbsp;Escala:
      span.shiftInfoItemValue &nbsp;{{ shift.scaleName }}
      span.shiftInfoItemDivisorLine
    .shiftInfoItem(v-if="shift.userName.length > 0")
      b.shiftInfoItemName &nbsp;Nome:
      span.shiftInfoItemValue &nbsp;{{ shift.userName }}
    .shiftInfoItem(v-if="hideProgress === false && shift.statusName.length > 0")
      b.shiftInfoItemName &nbsp;Status:
      span.shiftInfoItemValue &nbsp;{{ shift.statusName }}

</template>

<script>

  export default {
    name: 'SosShiftCard',

    props: {
      hideProgress: { type: Boolean, default: false },
      showValue: { type: Boolean, default: true },
      shift: { type: Object, required: true },
      showScaleName: { type: Boolean, default: false },
    },

    methods: {
      open () {
        this.$emit('open', this.shift)
      },
    },
  }

</script>

<style lang="scss" scoped>

  .shiftInfoItem {
    font-size: 0;
    line-height: 1.5;
  }

  .shiftInfoItemName {
    color: lightgreen;
    font-size: 14px;
    font-weight: 600;
  }

  .shiftInfoItemValue {
    font-size: 14px;
    font-weight: 500;
  }

  .shiftInfoItemDivisorLine {
    display: inline-block;
    width: 100%;
    height: 1px;
    margin: 5px 0;
    background-color: rgba(255, 255, 255, 0.5);
  }

  .shiftUserImageGroup {
    position: absolute;
    top: 0;
    right: 7px;
    bottom: 0;

    width: 45px;
    height: 65px;
    margin-top: auto;
    margin-bottom: auto;

    /* position: absolute;
    top: 0;
    right: 7px;
    bottom: 0;

    width: 50px;
    height: 55px;
    margin-top: auto;
    margin-bottom: auto; */

    > i {
      z-index: 2;
      position: absolute;
      top: 0;
      right: 5px;

      color: yellow;
      font-size: 20px;

      /* z-index: 2;
      position: absolute;
      top: 5px;
      right: 35px;

      transform: rotate(-35deg);

      font-size: 16px; */
    }
  }

  .shiftUserImage {
    position: absolute;

    margin-top: auto;
    margin-bottom: auto;

    display: inline-block;
    vertical-align: middle;
    width: 100%;
    height: 100%;
    max-width: 45px;
    max-height: 65px; // 45px;
    border-radius: 6px; // 50%;
    background-size: cover;
    background-position-x: center;
    background-position-y: center;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
    background-color: #d3d3d3;

    &--one {
      top: 0;
      right: 5px; // 7px;
      bottom: 0;
    }

    &--receiver {
      top: 0;
      right: 0;
      bottom: auto;

      max-width: 22.5px;
      max-height: 65px;

      filter: grayscale(1);

      /* top: 0;
      right: 0;
      bottom: auto;

      max-width: 30px;
      max-height: 30px; */
    }

    &--sender {
      top: 0;
      right: 22.5px;
      bottom: auto;

      max-width: 22.5px;
      max-height: 65px;
      box-shadow: 1px 1px 0px rgba(255, 255, 0, 1);

      /* top: 20px;
      right: 15px;
      bottom: auto;

      max-width: 35px;
      max-height: 35px; */
    }
  }

  .dutyUserValue {
    position: absolute;
    // bottom: 9px;
    // right: 7px;
    bottom: 4px;
    right: 5px;

    display: inline-block;
    vertical-align: middle;
    padding: 2px 3px;
    border-radius: 3px;
    background-image: linear-gradient(180deg, #ffffc5, #ffff00);

    color: #000;
    font-size: 12px;
    line-height: 12px;
    font-weight: 400;
    text-align: center;

    &--solo {
      bottom: 0px;
      right: 0px;
    }
  }

  .shiftStatus {
    position: absolute;
    top: 0;
    left: 0;

    width: 50%; // 100%;
    border-bottom-right-radius: 10px;
    // border-top: 1px solid rgba(0, 0, 0, 0.25);
    background-color: rgba(0, 0, 0, 0.35);

    color: #EEEEEE;
    font-size: 9px;
    font-weight: 800;
    line-height: 11px;
    text-align: center;
    letter-spacing: 0.5px;
  }

  /* .dutyDetails {
    z-index: 1;
    position: relative;

    display: inline-block;
    vertical-align: middle;
    width: 100%;
    padding: 9px 60px 9px 12px;
    text-align: left;
  } */

  .dutyDetailsUserName {
    line-height: 0;
  }

  .userNameValue {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;

    // padding-right: 5px;
    // padding-left: 2px;
    // padding-bottom: 2px;

    // border-radius: 7px;
    // background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.03), transparent);

    font-size: 13px;
    font-weight: 600;
    line-height: 1.2;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.7), 1px -1px 4px rgba(0, 0, 0, 0.4);
    text-overflow: ellipsis;
  }

  .shiftStartTimeTitle {
    color: cornsilk;
  }

  .shiftStartTime {
  }

  .dutyDetailsDurationText {
  }

  .shiftScaleNameTitle {
    color: #d9ff9e;
  }

  .shiftScaleName {
  }

  .shiftBodyItem {
    width: 100%; // Ellipsis
    overflow: hidden; // Ellipsis
    // padding-left: 2px;

    font-weight: 600;
    text-overflow: ellipsis; // Ellipsis
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.6), -1px -1px 3px rgba(0, 0, 0, 0.25);
  }

  .shift__card {
    cursor: pointer;

    position: relative;

    min-height: 75px;
    padding: 7px 55px 9px 10px;
    // padding: 9px 55px 9px 10px;
    // padding: 9px 60px 9px 10px;
    border-right: 1px solid rgba(255, 255, 255, 0.4);
    border-left: 1px solid rgba(255, 255, 255, 0.4);
    border-bottom: 1px solid rgba(0, 0, 0, 0.4);
    border-radius: 10px;
    box-shadow: inset 3px -3px 20px -3px rgba(0, 0, 0, 0.25);
    background-image: linear-gradient(360deg, rgba(0, 0, 0, 0.1), transparent);

    color: #FFFFFF;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    text-align: left;
    white-space: nowrap;

    overflow: hidden;

    // FLOATING LABEL
    &--hasLabel {
      padding: 21px 55px 4px 10px;
      // padding: 21px 60px 4px 10px;

      // padding: 14px 60px 4px 10px;
      // 21px 60px 9px 10px

      // Jesus
      /* .shiftUserImage--one {
        top: 12px;
      } */

      &.shift__card--hasScale {
        padding: 17px 55px 4px 10px;
      }
    }

    &--hasValue {
      .shiftUserImage--one {
        top: 5px; // 7px;
        margin-top: 0;
      }
    }

    /* &.shift__card--hasScale.shift__card--hasValue {
      .shiftUserImage--one {
        top: 13px;
      }

      .dutyUserValue {
        bottom: 13px;
      }
    } */

    /* &.shift__card--passando.shift__card--hasScale.shift__card--hasValue {
      .shiftUserImageGroup {
        top: 7px;
        margin-top: 0;
      }

      .dutyUserValue {
        bottom: 7px;
      }
    } */

    /* &.shift__card--passando.shift__card--hasValue {
      .shiftUserImageGroup {
        top: 2px;
        margin-top: 0;
      }

      .dutyUserValue {
        bottom: 2px;
      }
    } */

    &.shift__card--aberto {
      background-color: #00cb72;
    }

    // &.shift__card--requested {
      // background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.3), transparent);
    // }

    &.shift__card--fechado {
      background-color: #2196f3;

      &.shift__card--passando {
        background-color: #0f88fe;
      }
    }

    &.shift__card--vencido {
      // opacity: 0.6;
      opacity: 0.75;

      /* .userNameValue, .shiftStartTime, .dutyDetailsDurationText {
        // color: rgb(228, 228, 228);
        color: #f6f6f6;
      } */

      .shiftUserImage,
      .dutyUserValue {
        opacity: 0.9; // 0.8;
        filter: grayscale(1);
      }
    }

    &.shift__card--cancelado {
      background-color: #ff5a5a;
    }

    &.shift__card--pausado .shiftStatus {
      color: yellow;
      // border-bottom: 1px solid rgba(255, 255, 255, 0.3);
      background-color: indianred;
    }

    &.shift__card--passando .shiftStatus {
      color: yellow;
      // background-color: indianred;
    }
  }

  //
  //
  //

  .shift__card--aberto .shiftUserImage.shiftUserImage--one {
    background-size: auto;
    background-color: #e4e6e7;
  }
  .shift__card--aberto.shift__card--requested .shiftUserImage.shiftUserImage--one {
    background-position-y: center;
    background-size: auto;
    background-color: #e4e6e7;
  }

  //
  //
  //

  @media (max-width: 600px) {
    .userNameValue {
      max-width: 100%;
    }
  }

</style>
